// src/app/environment.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private env: any;

  constructor(private http: HttpClient) {}

  public loadEnvironment(): Promise<void> {
    // Sin parámetro al azar: el env.json tiene que salir de la caché del
    // service worker, la misma versión que el código que está corriendo.
    // nginx lo sirve con no-store, así que sin SW tampoco queda viejo.
    return firstValueFrom(this.http.get('/assets/env.json')).then((envData) => {
      this.env = envData;
    });
  }

  get APP_VERSION(): string {
    return this.env?.APP_VERSION;
  }

  get ENV(): string {
    return this.env?.ENV;
  }

  // Podés agregar más getters según lo que tengas en env.json
}
